import { getDeveloperContactsLabel } from 'shared/serp/components/header/developers_contacts';

import type { TContactParam } from '@cian/newbuilding-chat-component';

export function getNewbuildingChatSrc(chatContact: TContactParam) {
  const {
    realtyUserId,
    chat: { defaultMessage, entityId, context },
  } = chatContact;

  const gaLabel = getDeveloperContactsLabel(null);

  return (
    `/dialogs/?hostType=frame&entityId=${entityId}&entityType=newbuilding&receiverUserId=${realtyUserId}` +
    `${context ? '&context=' + encodeURIComponent(window.btoa(JSON.stringify(context))) : ''}` +
    `&defaultMessage=${encodeURIComponent(defaultMessage)}` +
    `&gaLabel=${encodeURIComponent(gaLabel)}` +
    '&noDefaultMsgIfChatExists=1' +
    '&pageType=Listing'
  );
}
